import isObject from 'lodash/isObject';
import isNull from 'lodash/isNull';

const $hnxSpinner = function () {
	const $spinners = {
		$global: {
			counter: 0,
			blocked: false
		}
	};
	
	const createObjectIfNotExists = function (name) {
		if (!isObject($spinners[name])) {
			$spinners[name] = {
				counter: 0,
				blocked: false
			};
		}
	};

	const show = function (name = '$global', delay = null) {
		createObjectIfNotExists(name);
		
		if ($spinners[name].blocked) {
			return;
		}
		
		if (isNull(delay)) {
			$spinners[name].counter++;
		} else {
			window.setTimeout(() => $spinners[name].counter++, delay);
		}
		return $spinners[name].counter > 0;
	};
	
	const hide = function (name = '$global', delay = null) {
		createObjectIfNotExists(name);
		
		if ($spinners[name].blocked) {
			return;
		}
		if ($spinners[name].counter > 0) {
			if (isNull(delay)) {
				$spinners[name].counter--;
			} else {
				window.setTimeout(() => $spinners[name].counter--, delay);
			}
		}
		return $spinners[name].counter > 0;
	};
	
	const status = function (name = '$global') {
		createObjectIfNotExists(name);
		return $spinners[name].counter > 0;
	};
	
	const reset = function (timeout = 1000, name = '$global') {
		createObjectIfNotExists(name);
		window.setTimeout(() => $spinners[name].blocked = false, timeout);
		$spinners[name].blocked = true;
		$spinners[name].counter = 0;
	};

	return {
		show, hide, status, reset, $spinners
	};
}();

export default $hnxSpinner;
